import axios, { AxiosError, AxiosRequestConfig, CancelTokenSource } from 'axios'
import CONFIG from 'config/constants'
import ls from 'utils/ls'

// axios.defaults.baseURL = process.env.REACT_APP_API_HOST
axios.defaults.headers.common['Content-Type'] = 'application/json'

const cancelSources: CancelTokenSource[] = []

axios.interceptors.request.use(
  (config) => {
    const token = ls.get(CONFIG.LSKEY_TOKEN)
    const cfg = config

    if (token && cfg.headers) {
      cfg.headers.Authorization = `Bearer ${token}`
      cfg.headers['X-API-Key'] = "xJJrUaBumt7eVVwmIFwgZ4Ku13IcLYaJsMvPkFIjI4ofXahCFG8Vtnl9KTjE4Dnm"
    }

    const cs = axios.CancelToken.source()
    cancelSources.push(cs)

    cfg.cancelToken = cs.token

    return cfg
  },
  (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error.response.data)
)

function cancelAll() {
  cancelSources.forEach((source) => source.cancel('Request cancelled'))
}

function isCancel(error: AxiosError) {
  return axios.isCancel(error)
}

function get<T>(url: string, config?: AxiosRequestConfig) {
  const res = axios.get<T>(url, config)
  return res
}

function post<T>(url: string, data: object, config?: AxiosRequestConfig) {
  const res = axios.post<T>(url, data, config)

  return res
}

function request(config: AxiosRequestConfig) {
  const res = axios(config)

  return res
}

const http = { get, post, cancelAll, isCancel, request }

export default http
